<div class="certificate-holder-entity-manager flex flex-col gap-6">
  <p-table scrollHeight="645px"
           scrollable="true"
           stripedRows="true"
           [attr.data-test]="testId() + '-table'"
           [value]="groupedRows()"
  >
    <ng-template #header>
      <tr>
        <th [id]="testId() + '-company'">Company</th>
        <th [id]="testId() + '-country'">Country</th>
        <th [id]="testId() + '-email'">Email</th>
        <th [id]="testId() + '-freetext'">Freetext</th>
        <th [id]="testId() + '-actions'"></th>
      </tr>
    </ng-template>
    <ng-template #body
                 let-row
    >
      @if (row.type === certificateHolderRowType.HOLDER) {
        <tr>
          <td>{{ row.companyName }}</td>
          <td>{{ row.country }}</td>
          <td></td>
          <td [pTooltip]="row.freetext">{{ row.freetext }}</td>
          <td>
            <div class="flex gap-1 justify-end">
              @if (row.uuid) {
                <span class="w-fit"
                      pTooltip="Open Certificate Holder"
                      tooltipPosition="left"
                >
                  <button iconOnly
                          pButton
                          severity="secondary"
                          type="button"
                          [attr.data-test]="testId() + '-open-certificate-holder'"
                          [disabled]="!canOpenCertificateHolder()"
                          [outlined]="true"
                          (click)="openCertificateHolder(row.uuid)"
                  >
                    <i class="pi pi-external-link"></i>
                  </button>
                </span>
              }
              <ng-container *ngTemplateOutlet="holderDisplayActions()?.templateRef ?? null; context: { $implicit: row, row: row }"/>
            </div>
          </td>
        </tr>
      } @else {
        <tr>
          <td colspan="2"></td>
          <td>{{ row.email }}</td>
          <td [pTooltip]="row.freetext">{{ row.freetext }}</td>
          <td>
            <div class="flex gap-1 justify-end">
              @if (row.uuid) {
                <span class="w-fit"
                      pTooltip="Open Certificate Holder"
                      tooltipPosition="left"
                >
                  <button iconOnly
                          pButton
                          severity="secondary"
                          type="button"
                          [attr.data-test]="testId() + '-open-certificate-holder'"
                          [disabled]="!canOpenCertificateHolder()"
                          [outlined]="true"
                          (click)="openCertificateHolder(row.uuid)"
                  >
                    <i class="pi pi-external-link"></i>
                  </button>
                </span>
              }
              <ng-container *ngTemplateOutlet="addressDisplayActions()?.templateRef ?? null; context: { $implicit: row, row: row }"/>
            </div>
          </td>
        </tr>
      }
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">{{ emptyMessage() }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div [formGroup]="searchForm()">
    <p class="certificate-headline mb-2">Search</p>
    <albert-input-wrapper [attr.data-test]="'wrapper-' + testId() + '-search'"
                          [disabled]="!canEdit()"
                          [tooltipLabel]="searchTooltip()"
    >
      <input class="w-full p-inputtext"
             formControlName="value"
             pInputText
             placeholder="Search by company name or email..."
             type="text"
             [attr.data-test]="testId() + '-search'"
             [id]="testId() + '-search'"
      />
    </albert-input-wrapper>
  </div>

  @if (searchResultRows().length > 0) {
    <div>
      <p class="certificate-headline mb-2">Search Results ({{ searchResultRowsByHolder().length }})</p>
      <p-table scrollHeight="400px"
               scrollable="true"
               stripedRows="true"
               [attr.data-test]="testId() + '-search-results-table'"
               [value]="searchResultRows()"
      >
        <ng-template #header>
          <tr>
            <th [id]="testId() + '-search-company'">Company</th>
            <th [id]="testId() + '-search-country'">Country</th>
            <th [id]="testId() + '-search-email'">Email</th>
            <th [id]="testId() + '-search-freetext'">Freetext</th>
            <th [id]="testId() + '-search-actions'"></th>
          </tr>
        </ng-template>
        <ng-template #body
                     let-row
        >
          @if (row.type === certificateHolderRowType.HOLDER) {
            <tr>
              <td>{{ row.companyName }}</td>
              <td>{{ row.country }}</td>
              <td></td>
              <td>{{ row.freetext }}</td>
              <td>
                <ng-container *ngTemplateOutlet="holderSearchActions()?.templateRef ?? null; context: { $implicit: row, row: row }"/>
              </td>
            </tr>
          } @else {
            <tr>
              <td colspan="2"></td>
              <td>{{ row.email }}</td>
              <td>{{ row.freetext }}</td>
              <td>
                <ng-container *ngTemplateOutlet="addressSearchActions()?.templateRef ?? null; context: { $implicit: row, row: row }"/>
              </td>
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  }
</div>
